import { AppBar, AppBarProps, Container } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { FC } from 'react'

export interface KBottomAppBarProps extends AppBarProps {
  direction?: 'row' | 'column'
}

export const KBottomAppBar: FC<KBottomAppBarProps> = ({
  children,
  direction = 'row',
  ...props
}) => {
  const theme = useTheme()
  return (
    <AppBar
      position="static"
      sx={{
        top: 'auto',
        bottom: 0,
        boxShadow: theme.custom.shadows[0],
        background: theme.palette.common.white,
        '& .MuiToolbar-root': {
          flexDirection: direction,
          gap: direction === 'column' ? theme.spacing(2) : 0,
          alignItems: direction === 'column' ? 'stretch' : 'center',
          [theme.breakpoints.down('sm')]: {
            gap: direction === 'column' ? theme.spacing(1) : 0,
          },
        },
      }}
      {...props}
    >
      <Container maxWidth="lg">{children}</Container>
    </AppBar>
  )
}
